export const activeClassname = 'onBase';
export const basePathDataValueKey = 'data-base-path-value';
export const homeBase = 0;
export const firstBase = 1;
export const secondBase = 2;
export const thirdBase = 3;
export const defaultBaseLabels = {
  [homeBase]: 'Home base',
  [firstBase]: 'First base',
  [secondBase]: 'Second base',
  [thirdBase]: 'Third base',
};
